import React from 'react'
import moment from 'moment'
import {
  Box,
  Text,
  Color,
  FontWeight,
  Display,
  FlexDirection,
  Divider,
} from '@gousto-internal/citrus-react'

type DeliveryDetailsProps = {
  deliverySlot: {
    date: string
    timeStart: string
    timeEnd: string
  }
  deliveryAddress: {
    line1: string
    line2?: string
    line3?: string
    town: string
    postcode: string
  }
}

export const DeliveryDetails = ({ deliverySlot, deliveryAddress }: DeliveryDetailsProps) => {
  return (
    <Box
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      width="100%"
      color={Color.ColdGrey_900}
      paddingV={3}
    >
      <Box>
        <Text fontWeight={FontWeight.Bold} size={8}>
          Delivery details
        </Text>
        <Box
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          gap={1}
          style={{ paddingTop: '0.5rem' }}
        >
          <Text fontWeight={FontWeight.Bold}>Date and time</Text>
          <Text>{moment(deliverySlot.date).format('dddd Do MMMM')}</Text>
          <Text size={2}>
            {moment(deliverySlot.timeStart, 'HH:mm:ss').format('h:mmA')} -{' '}
            {moment(deliverySlot.timeEnd, 'HH:mm:ss').format('h:mmA')}
          </Text>
          <Divider />
        </Box>
      </Box>

      <Box style={{ paddingTop: '1.5rem' }}>
        <Text fontWeight={FontWeight.Bold}>Delivery address</Text>
        <Box
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          gap={1}
          style={{ paddingTop: '0.5rem' }}
        >
          <Text>{deliveryAddress.line1}</Text>
          {deliveryAddress.line2 && <Text>{deliveryAddress.line2}</Text>}
          {deliveryAddress.line3 && <Text>{deliveryAddress.line3}</Text>}
          <Text>{deliveryAddress.town}</Text>
          <Text>{deliveryAddress.postcode}</Text>
          <Divider />
        </Box>
      </Box>
    </Box>
  )
}
